import React from 'react';

const Terms = () => {
  const terms = [
    'Prices are per board for the Quantity and Lead Time Days quoted.',
    'Lead Time Days are business days until the order ships, does not include transit time or cost.',
    'The Assembly Clock starts ticking the day after the PCBs, all the parts and required files are received',
    'For all orders placed before Noon PST, the next business day is Day 1.',
  ];

  return (
    <ul>
      {terms.map((term, index) => (<li key={index}>{term}</li>))}
    </ul>
  );
};

export default Terms;
